import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import { withRouter } from "react-router-dom";
import { get} from "lodash";

const styles = {
  manualOrder: {
    width: "100%",
    height: "44px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  quantity: {
    width: "50px"
  },
  interactPanel: {
    display: "flex",
    justifyContent: "space-evenly",
    alignItems: "center",

  },
  input: {
    width: "86px",
    height: "36px",
    borderRadius: "2px",
    border: "1px solid #00000066",
    textAlign: "center",
    margin: "0 12px",
  },
  button: {
    width: "86px",
    height: "36px",
    borderRadius: "2px",
    border: "1px solid #5f00a0",
    textAlign: "center",
    color: "#5f00a0",
    fontSize: "24px",
    backgroundColor: "white",
    userSelect: "none",
  }

};



const ManualOrder = (props) => {
  const { classes, base_bc_code } = props;

  const [value, setValue] = React.useState(0)

  React.useEffect(() => {
    setValue(props.amountToOrder)
    handleUpdateQuantity(props.amountToOrder)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleUpdateQuantity = num => {
    const updatedProductUnits = [...props.productUnits.filter(p => p.bc_code !== props.bc_code ) , {bc_code: props.bc_code, quantity: props.quantity, amountToOrder: num }];
    
    props.setTotalQuantity( updatedProductUnits.reduce((x,y) => x + calcUnitTotal(y.amountToOrder, y.quantity), 0) )
    props.setProductUnits( updatedProductUnits.sort((a,b) => a.quantity - b.quantity) )
  }

  const calcUnitTotal = (amt, mult) => {
    let tot = mult * amt;
    if (base_bc_code === 'EA') {
      tot = Math.round(tot);
    }
    return tot;
  }

  const handleSetValue = input => {
    const val = input.target.value;
    if (val === "") {
      setValue("")
      handleUpdateQuantity(parseInt(0))
    } else if (val !== "-" && val !== null && val !== undefined && !isNaN(parseInt(val))) { //val !== "" && val !== " " && 
      setValue(parseInt(val))
      handleUpdateQuantity(parseInt(val))
     } 
  }

  const handleFocus = (e) => {
    e.target.select()
  }

  const handleBlur = (e) => {
    const val = e.target.value;
     if (val === "") {
      setValue(0)
      handleUpdateQuantity(0)
     } 
  }

  const handleAdd = () => {
        setValue(value + 1)
        handleUpdateQuantity(value + 1)
  }
  const handleSubtract = () => {
    if (value > 0) {
      setValue(value - 1)
      handleUpdateQuantity(value - 1)
    }
  }

  return (
    <div className={classes.manualOrder} key={props.index}>
      <div className={classes.quantity}>X {props.quantity}</div>
      <div className={classes.interactPanel}>
        <button className={classes.button} onClick={() => handleSubtract()}>-</button>
        <input className={classes.input} inputMode="numeric" value={value} onFocus={handleFocus} onBlur={handleBlur} onChange={e => handleSetValue(e)}></input>
        <button className={classes.button} onClick={() => handleAdd()}>+</button>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    language: get(state, ["user", "language"]),
  };
};

export default withRouter(
  connect(mapStateToProps)(withStyles(styles)(ManualOrder))

);